import {
  Box,
  IconButton,
  Stack,
  Typography,
  useMediaQuery,
  useTheme,
  Grid,
} from "@mui/material";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import EventCard from "../Dashboard/Talent/Card/Featured_Card/EventCard";
import { useRef } from "react";
import { useNavigate } from "react-router-dom";
import { useTalentListStageCards } from "../../services/stagemode_api/talent/talent_api";
import { useCurrentTalentProfile } from "../../hooks";
import useCurrentBusinessInfo from "../../hooks/useCurrentBusiness";

const StageCards = () => {
  const scrollRef = useRef<HTMLDivElement>(null);

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const navigate = useNavigate();
  const { currentProfile } = useCurrentTalentProfile();
  const { currentBusiness } = useCurrentBusinessInfo();

  const talentId = currentProfile?.id ?? undefined;

  const businessId = currentBusiness?.id
    ? String(currentBusiness.id)
    : undefined;

  const { data } = useTalentListStageCards(talentId, businessId);
  const events = data?.data || [];

  const scrollBy = (offset: number) => {
    scrollRef.current?.scrollBy({ left: offset, behavior: "smooth" });
  };

  return (
    <Box px={{ xs: 2, sm: 3, md: 4 }} py={4}>
      <Stack
        direction="row"
        alignItems="center"
        justifyContent="space-between"
        sx={{ mb: { xs: 2, sm: 3 } }}
      >
        <Typography
          variant="h6"
          sx={{
            fontWeight: 700,
            fontSize: { xs: "1.1rem", sm: "1.25rem" },
            color: "text.primary",
          }}
        >
          {currentProfile ? "My Stage Cards" : "Available Events"}
        </Typography>

        <Stack direction="row" spacing={1}>
          <IconButton
            onClick={() => scrollBy(-400)}
            sx={{
              border: "1px solid #E5E7EB",
              borderRadius: 2,
              backgroundColor: "#fff",
              p: 1,
              transition: "all 0.2s ease",
              "&:hover": {
                backgroundColor: "#F3F4F6",
              },
            }}
            aria-label="scroll left"
          >
            <ChevronLeftIcon fontSize="small" />
          </IconButton>
          <IconButton
            onClick={() => scrollBy(400)}
            sx={{
              border: "1px solid #E5E7EB",
              borderRadius: 2,
              backgroundColor: "#fff",
              p: 1,
              transition: "all 0.2s ease",
              "&:hover": {
                backgroundColor: "#F3F4F6",
              },
            }}
            aria-label="scroll right"
          >
            <ChevronRightIcon fontSize="small" />
          </IconButton>
        </Stack>
      </Stack>

      <Grid container spacing={3}>
        {events.length > 0 ? (
          events.map((event: any) => (
            <Grid
              item
              key={event.id}
              xs={12}
              sm={6}
              md={4}
              onClick={() => navigate(`/featured-event/${event.id}`)}
              sx={{
                cursor: "pointer",
                transition: "transform 0.2s ease",
                "&:hover": {
                  transform: "scale(1.02)",
                },
              }}
            >
              <EventCard event={event} />
            </Grid>
          ))
        ) : (
          <Grid item xs={12}>
            <Typography variant="body2" color="text.secondary" sx={{ px: 2 }}>
              No stage cards available at the moment.
            </Typography>
          </Grid>
        )}
      </Grid>
    </Box>
  );
};

export default StageCards;
